import React from 'react'
import { Outlet } from 'react-router-dom'

const DeviceProfile = () => {
  return (
    <>
      <Outlet />
    </>
  )
}

export default DeviceProfile
